<script setup lang="ts">
  import { ref, watch } from 'vue';

  const props = defineProps<{
    url: string;
    fileName: string;
    mimeType?: string | null;
  }>();

  const textContent = ref<string>('');
  const loading = ref(false);
  const error = ref<string | null>(null);

  const loadTextContent = async () => {
    loading.value = true;
    error.value = null;

    try {
      const response = await fetch(props.url);
      if (!response.ok) throw new Error('Failed to load file');
      textContent.value = await response.text();
    } catch (err) {
      error.value = err instanceof Error ? err.message : 'Failed to load file';
    } finally {
      loading.value = false;
    }
  };

  watch(() => props.url, loadTextContent, { immediate: true });
</script>

<template>
  <div class="flex h-full flex-col">
    <div v-if="loading" class="flex items-center justify-center p-8">
      <span class="text-muted-foreground">Loading...</span>
    </div>

    <div v-else-if="error" class="flex items-center justify-center p-8">
      <span class="text-destructive">{{ error }}</span>
    </div>

    <div v-else class="flex-1 overflow-auto">
      <pre class="font-mono text-sm leading-relaxed whitespace-pre-wrap break-words">{{
        textContent
      }}</pre>
    </div>
  </div>
</template>
